import { Skeleton as MuiSkeleton } from '@mui/material';
import styled from 'styled-components';

export const Skeleton = styled(MuiSkeleton)`
  && {
    width: 8rem;
    height: 1.75rem;
    margin-bottom: -0.25rem;
    border-radius: ${({ theme }) => theme.shape.tagRadius};
    background-color: ${({ theme }) => theme.palette.text.secondary}33;
  }
`;

export const TagSkeleton = styled(MuiSkeleton)`
  && {
    border-radius: ${({ theme }) => theme.shape.tagRadius};
    height: 2rem;
    width: 4rem;
    background-color: ${({ theme }) => theme.palette.text.secondary}33;
  }
`;

export const ChipSkeleton = styled(MuiSkeleton)`
  && {
    border-radius: ${({ theme }) => theme.shape.tagRadius};
    height: 1.625rem;
    width: 2.25rem;
    background-color: ${({ theme }) => theme.palette.text.secondary}33;
  }
`;

export const PaperSkeleton = styled(MuiSkeleton)`
  min-height: 2rem;
  min-width: 8rem;
  border-radius: ${({ theme }) => theme.shape.containerRadius};
  background-color: ${({ theme }) => theme.palette.background.paper};
  transform: unset !important;
`;
